import React, { useEffect, useRef, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { IconButton } from '@mui/material';
import useAxiosProtect from '../../../../../../hooks/useAxiosProtect';
import HubModal from './HubModal';

const HubRegistry = props => {
    const axiosProtect = useAxiosProtect();
    const initialized = useRef(false);
    const siteId = Number(window.location.href.split('/').slice(-1));

    const [hubs, setHubs] = useState([]);
    const [modalState, setModalState] = useState(undefined);
    const [hubToEdit, setHubToEdit] = useState(null);
    const [hubToDelete, setHubToDelete] = useState(null);

    const sortHubs = rows => [...rows].sort((a, b) => {
        const nameComparison = a.name.localeCompare(b.name);
        if(nameComparison !== 0) return nameComparison;

        const supplierComparison = a.supplier_name.localeCompare(b.supplier_name);
        if(supplierComparison !== 0) return supplierComparison;

        const aIdentifier = a.edgecom_location_name || a.deveui || '';
        const bIdentifier = b.edgecom_location_name || b.deveui || '';
        return aIdentifier.localeCompare(bIdentifier);
    });

    useEffect(() => {
        if(initialized.current) return;
        initialized.current = true;

        const controller = new AbortController();

        axiosProtect.get(`/v2s/v2-sensors/hubs?site_id=${siteId}`, {
            signal: controller.signal
        }).then(response => {
            setHubs(sortHubs(response.data.hubs));
        }).catch(error => {
            if(error.name !== 'CanceledError') console.log(error);
        });

        return () => controller.abort();
    }, []);

    useEffect(() => {
        props.updateSensorCount('hub', hubs.length);
    }, [hubs]);

    const closeModal = () => {
        setModalState(undefined);
        setHubToEdit(null);
        setHubToDelete(null);
    };

    const openModal = (state, hub = null) => {
        if(state === 'edit') setHubToEdit(hub);
        if(state === 'delete') setHubToDelete(hub);
        setModalState(state);
    };

    const saveHub = hub => {
        setHubs(previous => {
            const exists = previous.some(current => current.id === hub.id);
            return sortHubs(exists
                ? previous.map(current => current.id === hub.id ? hub : current)
                : [...previous, hub]);
        });
    };

    const deleteHub = hubId => {
        setHubs(previous => previous.filter(hub => hub.id !== hubId));
    };

    return (
        <div>
            {modalState !== undefined && (
                <HubModal
                    modalState={modalState}
                    closeModal={closeModal}
                    hubToEdit={hubToEdit}
                    hubToDelete={hubToDelete}
                    saveHub={saveHub}
                    deleteHub={deleteHub}
                />
            )}

            <Button
                onClick={() => openModal('add')}
                variant="outline-dark"
                style={{marginBottom: '1.5%'}}
            >
                <strong>Add hub</strong>
            </Button>

            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Supplier</th>
                        <th>DevEUI</th>
                        <th>Edgecom location name</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {hubs.map(hub => (
                        <tr key={hub.id}>
                            <td>{hub.name}</td>
                            <td>{hub.supplier_name}</td>
                            <td>{hub.supplier_name === 'Milesight' ? hub.deveui : 'N/A'}</td>
                            <td>{hub.supplier_name === 'Edgecom' ? hub.edgecom_location_name : 'N/A'}</td>
                            <td>
                                <IconButton onClick={() => openModal('delete', hub)}>
                                    <DeleteTwoToneIcon style={{fill: 'red'}}/>
                                </IconButton>
                                <IconButton onClick={() => openModal('edit', hub)}>
                                    <EditTwoToneIcon/>
                                </IconButton>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default HubRegistry;
